import { createRouter, createWebHistory } from 'vue-router'
import Generator from '../views/Generator.vue'


const routes = [
  {
    path: '/',
    name: 'Generator',
    component: Generator
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
